module.exports = __webpack_public_path__ + "assets/img/logo.a3f7edd4.png";